export default __webpack_public_path__ + "static/media/Asset-77.68315470.png";